//Black bar at top of the screen. Contains UI logo
import * as React from "react";
import { Button, Toolbar, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HeaderLogo from "./HeaderLogo";
import { useBrandingContext } from "../../BrandingContext";

export default function Header() {
  const { branding } = useBrandingContext();
  var currentURL = new URL(window.location.href);
  var searchParams = new URLSearchParams(currentURL.search);

  const navigate = useNavigate();

  let tokenType = searchParams.get("tokenType");
  let emailToken = searchParams.get("token");

  const searchString = [
    emailToken && `token=${encodeURIComponent(emailToken)}`,
    tokenType && `tokenType=${encodeURIComponent(tokenType)}`,
  ]
    .filter(Boolean)
    .join("&");

  return (
    <Toolbar
      sx={{
        display: "flex",
        justifyContent:
          window.location.pathname !== "/login" && window.location.pathname !== "/"
            ? "space-between"
            : "flex-end",
        mb: 4,
      }}
    >
      {!["/login", "/", "/select-account-type", "/error"].includes(window.location.pathname) && (
        <>
          <a
            className="navigateToUI"
            href={branding?.homeUrl ? branding?.homeUrl : "https://www.uicharitable.org"}
            target="_blank"
            rel="noopener noreferrer"
          >
            <HeaderLogo boxSx={{ height: { xs: "50px", sm: "50px", md: "50px", lg: "50px" } }} />
          </a>
          <Button
            id="headerSignIn"
            onClick={() =>
              navigate({
                pathname: `/login`,
                search: searchString ? `?${searchString}` : "",
              })
            }
          >
            <Typography sx={{ color: "secondary.main", textTransform: "capitalize" }}>
              Sign In
            </Typography>
          </Button>
        </>
      )}
    </Toolbar>
  );
}
